// extracted by mini-css-extract-plugin
export default {"statistics-container":"WorkHoursReportStatistics_statistics-container__LOtgS","statistics-card":"WorkHoursReportStatistics_statistics-card__tkFqb"};